<template>
  <div style="border: 1px solid #ccc; margin-top: 10px">
    <!-- 工具栏 -->
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" />
    <!-- 编辑器 -->
    <Editor :class="{ disabled: isReadOnly }" style="height: 600px; overflow-y: hidden" :defaultConfig="editorConfig"
      :disabled="isReadOnly" v-model="html" @onChange="onChange" @onCreated="onCreated" />
  </div>
</template>

<script>
import { compress } from "@/utils/compress-img.js"
import { Editor, Toolbar } from "@wangeditor/editor-for-vue"
// 打印工具栏 配置项 使用
// import { DomEditor } from "@wangeditor/editor"
import { commonApi } from "@/api"
const insertImgList = [] // 插入图片列表
export default {
  name: "MyEditor",
  components: { Editor, Toolbar },
  props: {
    // 编辑时 直接把插入的列表渲染
    contentHtml: {
      type: String,
      default: ""
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentImgList: [], // 最开始的 图片列表
      editor: null,
      html: "",
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        excludeKeys: [
          /* 隐藏哪些菜单 */
          "group-video",
          "codeBlock",
          "insertImage", // 避免引用的网络图片来源于同一个 导致删除后 其他商品详情 也没有掉的问题 
          "emotion" // 表情
        ]
      }
    }
  },
  computed: {
    // https://www.wangeditor.com/v5/menu-config.html#%E4%B8%8A%E4%BC%A0%E5%9B%BE%E7%89%87 文档
    editorConfig() {
      const _this = this
      return {
        placeholder: "请输入内容...",
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            server: process.env.VUE_APP_BASE_URL + "/xiaobuAdmin/common/upload",
            fieldName: "file",
            async customUpload(file, insertFn) { // JS 语法
              // file 即选中的文件
              // 自己实现上传，并得到图片 url alt href
              const formData = new FormData()
              const newFile = await compress(file)
              formData.append("file", newFile, newFile.name)
              const res = await commonApi.upload(formData)
              const url = _this.mixinFileServer + res.url
              const alt = res.name
              const href = _this.mixinFileServer + res.url
              // 最后插入图片
              insertFn(url, alt, href)
            }
          },
          insertImage: {
            onInsertedImage(imageNode) { // JS 语法
              if (imageNode == null) { return }
              // const { src, alt, url, href } = imageNode
              // 记录插入过的图片
              insertImgList.push(imageNode)
            }
          }
        }
      }
    }
  },
  watch: {
    contentHtml: {
      handler: function(newVal) {
        if (!newVal || !this.editor) { return }
        this.html = newVal
      },
      immediate: true
    },
    isReadOnly: {
      handler: function(val) {
        setTimeout(() => {
          const editor = this.editor
          if (editor == null) {
            return
          }
          if (val) {
            editor.disable()
          } else {
            editor.enable()
          }
        }, 200)
      },
      immediate: true
    }
  },
  methods: {
    // 获取富文本中的图片
    getImgList() {
      const editor = this.editor
      if (editor == null) {
        return []
      }
      const imgList = editor.getElemsByType("image")
      return imgList
    },
    // 获取插入过的图片 和 最终文本的图片
    getInsertImgListAndResultImgList() {
      return {
        insertImgList: insertImgList.concat(this.currentImgList).map(item => {
          return item.src
        }),
        resultImgList: this.getImgList().map(item => {
          return item.src
        })
      }
    },
    // 获取结果
    getEditorResult() {
      const editor = this.editor
      const imgResult = this.getInsertImgListAndResultImgList()
      return {
        ...imgResult,
        html: editor && editor.getHtml()
      }
    },

    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错

      // 渲染完成后 给最开始的 图片列表赋值 
      this.$nextTick(() => {
        setTimeout(() => { // 加个延迟 否则可能获取不到初始图片列表
          // console.log(this.editor.getAllMenuKeys()) //打印所有注册的菜单Key
          // const toolbar = DomEditor.getToolbar(this.editor)
          // const curToolbarConfig = toolbar.getConfig()
          // //工具栏菜单  配置工具栏时 可参考
          // console.log(curToolbarConfig.toolbarKeys) //打印当前菜单的排序、分组

          // 获取当前图片数据 供提交时 删除 之前选中的图片列表
          this.currentImgList = this.getImgList()
        }, 1000)
      })
    },
    onChange(editor) {
      // console.log("onChange", editor.getHtml()) // onChange 时获取编辑器最新内容
    },
    insertTextHandler(content) {
      const editor = this.editor
      if (editor == null) {
        return
      }
      editor.insertText(content)
    },
    printEditorHtml() {
      const editor = this.editor
      if (editor == null) {
        return
      }
      console.log(editor.getHtml())
      return editor.getHtml()
    },
    disableHandler() {
      const editor = this.editor
      if (editor == null) {
        return
      }
      editor.disable()
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) {
      return
    }
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.disabled {
  ::v-deep .w-e-text-container {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
  }
}
</style>
